import client from './client'

export const init = ({ apiUrl, code }) => {
	client.defaults.baseURL = apiUrl
	client.interceptors.request.use((config) => {
		config.data = {
			...config.data,
			key: code,
		}
		return config
	})
	return client
}

export default init
